import { defineStore } from 'pinia'
import BillingEntityService from '@/api/BillingEntityService.js'

export const useBillingEntityStore = defineStore('billingEntity', {
    state: () => ({
        billingEntityData: {
            id: null,
            name: '',
            logo: null,
            logo_url: null,
            vat_number: '',
            company_registration_number: '',
            address_line1: '',
            address_line2: '',
            postal_code: '',
            city: '',
            country: '',
            bank_name: '',
            bank_iban: '',
            bank_bic: '',
            bank_address_line1: '',
            bank_address_line2: '',
            bank_postal_code: '',
            bank_city: '',
            show_name_on_top: false,
            show_serviced_by: false,
        },

        billingEntityTableRefreshKey: 0,
        loading: false,
        saving: false,
    }),

    actions: {
        notification(severity, detail) {
            const summary = severity === 'error' ? 'Error' : 'Success'
            this.toast.add({
                severity,
                summary,
                detail,
                life: this.getToastDuration(detail, severity),
            })
        },

        resetState() {
            this.billingEntityData = {
                id: null,
                name: '',
                logo: null,
                logo_url: null,
                vat_number: '',
                company_registration_number: '',
                address_line1: '',
                address_line2: '',
                postal_code: '',
                city: '',
                country: '',
                bank_name: '',
                bank_iban: '',
                bank_bic: '',
                bank_address_line1: '',
                bank_address_line2: '',
                bank_postal_code: '',
                bank_city: '',
                show_name_on_top: false,
                show_serviced_by: false,
            }
        },

        async getBillingEntityData(billingEntity) {
            this.loading = true
            try {
                const data = await BillingEntityService.get(billingEntity)
                Object.keys(data).forEach((key) => {
                    if (this.billingEntityData[key] !== undefined) {
                        this.billingEntityData[key] = data[key]
                    }
                })
            } catch (error) {
                console.error('Error fetching billing entity data (stores/billingEntity/getBillingEntityData):', error)
            } finally {
                this.loading = false
            }
        },

        async downloadLogo() {
            try {
                await BillingEntityService.downloadLogo({
                    id: this.billingEntityData.id,
                    name: this.billingEntityData.name,
                })
            } catch (error) {
                console.error('Error downloading logo (stores/billingEntity/downloadLogo):', error)
            }
        },
    },
})
